<div class="section__title">
  <h1>Concesionarios</h1>
  <div class="cont__options_title">
    <app-distributor-menu></app-distributor-menu>
    <div class="btn-titles">
      <button type="button" (click)="downloadExcel()" class="btn btn-outline-secondary">
        <i class="fa-solid fa-file-excel"></i> Descargar Excel
      </button>
      <button type="button" [routerLink]="['/admin/distributor/edit']" class="btn-primary">
        <i class="fas fa-plus"></i> Nuevo concesionario
      </button>
    </div>
  </div>
</div>
<table
  id="tbldistributor"
  datatable
  [dtOptions]="dtOptions"
  [dtTrigger]="dtTrigger"
  class="table dense__table table-striped data-tables w-100"
>
  <thead>
    <tr>
      <th class="text-start">Razón Social</th>
      <th>Cif</th>
      <th>Nº cuenta</th>
      <th>Grupo PV</th>
      <th>Placa VN</th>
      <th>Sector Renault</th>
      <th>Sector Dacia</th>
      <th>Instalaciones</th>
      <th>Estado</th>
      <th width="92px">Opciones</th>
    </tr>
  </thead>
</table>

<div class="row">
  <div class="col-lg-6">
    <label class="form-label">Fichero de actualización de puntos de red</label><br />
    <small>Este proceso no borra puntos de red, solo añade y actualiza información</small><br />
    <ngx-dropzone
      class="rounded-0 mb-sm-2"
      id="dz"
      (change)="onFileSelect($event)"
      [multiple]="false"
    >
      <ngx-dropzone-label class="bg-cropper_label">
        Arrastra el archivo para subirlo o<br /><span class="btn btn-invert"
          >Seleccionar archivo</span
        >
      </ngx-dropzone-label>
      @for (f of file; track f) {
        <ngx-dropzone-preview
          ngProjectAs="ngx-dropzone-preview"
          [file]="f"
          [removable]="true"
          (removed)="onFileRemove(f)"
        >
          <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
        </ngx-dropzone-preview>
      }
    </ngx-dropzone>
    <div class="buttons_form_actions">
    <button class="btn-primary" (click)="UpdateDistributorExcel()">ACTUALIZAR</button>
    <a
      href="{{ blobPublic }}Templates/DistributorLoad/TEMPLATE_LOAD_DISTRIBUTOR.xlsx"
      class="btn btn-outline-secondary"
      ><i class="fa fa-download" aria-hidden="true"></i> Plantilla de carga</a
    ></div>
  </div>

  <distributor-fileload></distributor-fileload>
</div>
